import { create } from 'zustand';
import { IFFErrorStore } from './types';

export const useFactFindErrorStore = create<IFFErrorStore>((set) => ({
  ffErrors: null,
  updateFFErrorStore: ({ ffErrors }) => set(() => ({ ffErrors: ffErrors })),
}));

export default useFactFindErrorStore;
